import { render } from "./AddComptePage.vue?vue&type=template&id=53bb666f&ts=true"
import script from "./AddComptePage.vue?vue&type=script&lang=ts"
export * from "./AddComptePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__